import $ from 'jquery'

$(document).ready(function () {
  initUpcomingWebinarsAccordion()
  initUpcomingWebinarsLoadMore()
})

function initUpcomingWebinarsAccordion() {
  $('.dhsv_vc_upcoming_webinars').each(function () {
    const $module = $(this)
    $module.find('.upcoming-webinars-accordion').each(function () {
      const $accordion = $(this)
      const $items = $accordion.find('.upcoming-webinars-accordion__item')

      $items.each(function () {
        const $item = $(this)
        const $toggle = $item.find('.upcoming-webinars-accordion__header')
        const $content = $item.find('.upcoming-webinars-accordion__content')

        $content.slideUp(0)
        $item.removeClass('is-open')
        $toggle.attr('aria-expanded', 'false')

        $toggle.on('click', function (e) {
          e.preventDefault()
          const isOpen = $item.hasClass('is-open')

          if (isOpen) {
            $content.slideUp(300)
            $item.removeClass('is-open')
            $toggle.attr('aria-expanded', 'false')
          } else {
            $items.not($item).each(function () {
              $(this).find('.upcoming-webinars-accordion__content').slideUp(300)
              $(this).removeClass('is-open')
              $(this)
                .find('.upcoming-webinars-accordion__toggle')
                .attr('aria-expanded', 'false')
            })
            $content.slideDown(300)
            $item.addClass('is-open')
            $toggle.attr('aria-expanded', 'true')
          }
        })
      })
    })
  })
}

function initUpcomingWebinarsLoadMore() {
  $('.dhsv_vc_upcoming_webinars').each(function () {
    const $module = $(this)
    const $list = $module.find('.upcoming-webinars__list')
    const $loadMoreBtn = $module.find('.upcoming-webinars__load-more')

    if (!$list.length || !$loadMoreBtn.length) {
      return
    }

    const displayCount = parseInt($module.data('display-count'), 10) || 2
    const $cards = $list.find('.upcoming-webinars__card')
    const $hiddenCards = $cards.filter('.upcoming-webinars__card--hidden')

    if (!$hiddenCards.length) {
      return
    }

    $loadMoreBtn.on('click', function () {
      const $currentlyHidden = $list.find('.upcoming-webinars__card--hidden')
      const toReveal = $currentlyHidden.slice(0, displayCount)
      toReveal.removeClass('upcoming-webinars__card--hidden')

      const remainingHidden = $list.find('.upcoming-webinars__card--hidden')
      if (!remainingHidden.length) {
        $loadMoreBtn.closest('.upcoming-webinars__footer').hide()
      }
    })
  })
}
